// Fix for shopify-payment-terms visibility in shadow DOM
window.addEventListener('load', () => {
  const paymentTerms = document.querySelector('shopify-payment-terms');
  
  if (paymentTerms && paymentTerms.shadowRoot) {
    const style = document.createElement('style');
    style.textContent = `
      #prequalBackupCTA > button {
        text-decoration: none !important;
        border-bottom: 1px solid black;
      }
    `;
    paymentTerms.shadowRoot.appendChild(style);
  }
});
